import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";

import PasswordChange from "./components/PasswordChange";
import AccountDetails from "./components/AccountDetails";
import { useAuth } from "@/hooks/useAuth";

const Profile = () => {

    // Get layout header setter from outlet context
    const setHeader = useOutletContext();

    const { user } = useAuth();

    // Set page header when component mounts
    useEffect(() => {

        // Update layout header
        setHeader({
            title: "My Profile",
            subTitle: "Update your account details",
        });

        // Cleanup header when component unmounts
        return () => {
            setHeader({
                title: "",
                subTitle: "",
            });
        };

    }, []);

    return (
        <div className="flex flex-col gap-4" style={{ zoom: 0.92 }}>

            {/* Profile sections grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">

                {/* Account details card */}
                <AccountDetails />

                {/* Password change card — hidden only for an account that
                    actually signs in through Active Directory, whose password
                    lives in the corporate directory and cannot be changed
                    here. Read off this row's own provider rather than the
                    tenant's flag: an invited local user on a tenant that later
                    turned AD on still has a password to change. */}
                {user.authProvider !== "ad" && <PasswordChange />}

            </div>

            {/* Additional note */}
            <div className="text-[14px] text-text-secondary">
                Email and username are read-only.
            </div>

        </div>
    );
};

export default Profile;
